import PropTypes from "prop-types"
import React from "react"

import { useOpen } from "./hooks/useOpen"
import {
  CollapsibleContainer as Container,
  CollapsibleIcon as Icon,
  CollapsibleInnerContainer as Inner,
  CollapsibleTitle as Title,
} from "./styled"

/**
 * A collapsbible content with title and self controlled state
 */
export function Collapsible({
  title,
  children,
  initialOpen = false,
  scrollWhenOpen,
  id,
  onToogle,
  closeTime = 0.2,
  isControlled,
  openTime = 0.3,
  open = false,
  openIcon = "▼",
  closeIcon = "▲",
  className,
}) {
  const { titleRef, isOpen, handleToogle, containerRef } = useOpen({
    open,
    isControlled,
    closeTime,
    openTime,
    scrollWhenOpen,
    initialOpen,
    onToogle,
  })

  const iconToUse = isOpen ? closeIcon : openIcon

  return (
    <Container className={className}>
      <Title role="tab" id={id} ref={titleRef} onClick={handleToogle} aria-expanded={String(isOpen)}>
        {title}
        <Icon>{iconToUse}</Icon>
      </Title>
      <Inner
        role="tabpanel"
        $show={isOpen}
        aria-labelledby={id}
        ref={containerRef}
        $openTime={openTime}
        $closeTime={closeTime}
      >
        {children}
      </Inner>
    </Container>
  )
}

Collapsible.propTypes = {
  /**
   * Html ID will be used for a11y. If not set a randon rash will be added
   */
  id: PropTypes.string,
  /**
   * Clickable title
   */
  title: PropTypes.node.isRequired,
  /**
   * If uncontrolled will set the collapsible to this initial state
   */
  initialOpen: PropTypes.bool,
  /**
   * If isControlled controls the open state▲
   */
  open: PropTypes.bool,
  /**
   * If true will not use the internal state
   */
  isControlled: PropTypes.bool,
  /**
   * If true will scroll when open
   */
  scrollWhenOpen: PropTypes.bool,
  /**
   * Fires with the new tab state
   */
  onToogle: PropTypes.func,
  /**
   * Time for the close animation,also used for scrolling purposes
   */
  closeTime: PropTypes.number,
  /**
   * Time for the open animation,also used for scrolling purposes
   */
  openTime: PropTypes.number,
  /**
   * The content to be shown when open
   */
  children: PropTypes.node.isRequired,
  /**
   * Icon to show when the collapsible is CLOSED and needs to be opened
   * @default ▼
   */
  openIcon: PropTypes.node,
  /**
   * Icon to show when the collapsible is OPENED and needs to be closed
   * @default ▲
   */
  closeIcon: PropTypes.node,
}
